/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AreaFilterContext } from './AreaFilterContext';
import {
    AreaFilterContextFromJSON,
    AreaFilterContextFromJSONTyped,
    AreaFilterContextToJSON,
    AreaFilterContextToJSONTyped,
} from './AreaFilterContext';

/**
 * 
 * @export
 * @interface NamedAreaFilter
 */
export interface NamedAreaFilter {
    /**
     * 
     * @type {string}
     * @memberof NamedAreaFilter
     */
    type: NamedAreaFilterTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NamedAreaFilter
     */
    nameType?: NamedAreaFilterNameTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NamedAreaFilter
     */
    name: string;
    /**
     * 
     * @type {AreaFilterContext}
     * @memberof NamedAreaFilter
     */
    context?: AreaFilterContext;
}


/**
 * @export
 */
export const NamedAreaFilterTypeEnum = {
    NamedAreaFilter: 'NamedAreaFilter'
} as const;
export type NamedAreaFilterTypeEnum = typeof NamedAreaFilterTypeEnum[keyof typeof NamedAreaFilterTypeEnum];

/**
 * @export
 */
export const NamedAreaFilterNameTypeEnum = {
    StreetAndNumber: 'street-and-number',
    Street: 'street',
    Neighborhood: 'neighborhood',
    ZipCode: 'zip-code',
    City: 'city',
    County: 'county',
    StateAbbreviated: 'state-abbreviated',
    District: 'district',
    SubDistrict: 'sub-district',
    SchoolDistrict: 'school-district'
} as const;
export type NamedAreaFilterNameTypeEnum = typeof NamedAreaFilterNameTypeEnum[keyof typeof NamedAreaFilterNameTypeEnum];


/**
 * Check if a given object implements the NamedAreaFilter interface.
 */
export function instanceOfNamedAreaFilter(value: object): value is NamedAreaFilter {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NamedAreaFilterFromJSON(json: any): NamedAreaFilter {
    return NamedAreaFilterFromJSONTyped(json, false);
}

export function NamedAreaFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): NamedAreaFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'nameType': json['nameType'] == null ? undefined : json['nameType'],
        'name': json['name'],
        'context': json['context'] == null ? undefined : AreaFilterContextFromJSON(json['context']),
    };
}

export function NamedAreaFilterToJSON(json: any): NamedAreaFilter {
    return NamedAreaFilterToJSONTyped(json, false);
}

export function NamedAreaFilterToJSONTyped(value?: NamedAreaFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'nameType': value['nameType'],
        'name': value['name'],
        'context': AreaFilterContextToJSON(value['context']),
    };
}

